export default {"src":"/_next/static/media/Verified-Badge.eb27e864.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};